export default __webpack_public_path__ + "static/media/Bow of the Haunter in the Dark.a61e6cde.jpg";